import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
// @mui
import { Stack, IconButton, InputAdornment, TextField, createTheme, ThemeProvider } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Swal from 'sweetalert2';
import { authService } from '../../../services/authService';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const theme = createTheme({
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              border: '2px solid white',
              color: 'white',
            },
            '&:hover fieldset': {
              borderColor: '#5756A2',
            },
          },
        },
      },
    },
  },
});

export default function SignupForm() {
  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { email } = useParams();

  const queryParams = new URLSearchParams(window.location.search);
  const locationId = queryParams.get('locationId');

  const Navigate = useNavigate();

  const landlogin = (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (loader) return;

    if (!password || !confirmPassword) {
      Swal.fire({
        title: 'Please enter and confirm your password.',
        icon: 'error',
      });
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire({
        title: 'Passwords do not match.',
        text: 'New password and confirm password must be the same.',
        icon: 'error',
      });
      return;
    }

    setLoader(true);

    authService
      .register({ email, password, confirmPassword, locationId })
      .then((response) => {
        authService.persistSession({
          accessToken: response?.accessToken,
          refreshToken: response?.refreshToken,
          locationId,
          email: email.toLowerCase(),
        });
        setLoader(false);
        Navigate('/dashboard/app');
      })
      .catch((resError) => {
        setLoader(false);
        Swal.fire({
          title: resError?.response?.data?.message || 'Registration failed. Please try again.',
          icon: 'error',
        });
      });
  };

  return (
    <>
      <form onSubmit={landlogin}>
        <Stack spacing={3}>
          <div>
            Account: <strong>{locationId}</strong>
            <br />
            Email: <strong>{email.toLowerCase()}</strong>
          </div>
          <ThemeProvider theme={theme}>
            <TextField
              name="newPassword"
              label="New password"
              placeholder="New password"
              onChange={(e) => setPassword(e.target.value)}
              variant="filled"
              type={showPassword ? 'text' : 'password'}
              autoComplete="new-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      aria-label="toggle password visibility"
                    >
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              name="confirmPassword"
              label="Confirm password"
              placeholder="Confirm password"
              onChange={(e) => setConfirmPassword(e.target.value)}
              variant="filled"
              type={showConfirmPassword ? 'text' : 'password'}
              autoComplete="new-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      edge="end"
                      aria-label="toggle confirm password visibility"
                    >
                      <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </ThemeProvider>
        </Stack>

        <LoadingButton
          loading={loader}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          sx={{ marginTop: 5, color: '#FFF', backgroundColor: '#012367' }}
        >
          Signup
        </LoadingButton>
      </form>
    </>
  );
}
